class ManageController {
  constructor (googleAnalytics) {
    const vm = this;
    vm.name = 'manage';
    googleAnalytics.setPage('ניהול', 'manage');
  }
}

export default ManageController;
